// removed by extract-text-webpack-plugin
module.exports = {"submenu-display":"main_nav-Kud","submenu-display-wrapper":"main_nav-1CY","content":"main_nav-1j2","display-list":"main_nav-1Lx","intro":"main_nav-2yJ","mobile-collapsed":"main_nav-2c8","submenu-display-active":"main_nav-3km"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/ProductDisplay/product_display.module.scss
// module id = 131
// module chunks = 0